import { ButtonProps } from '@almbrand/button';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export type MobileVariation = 'default' | 'fullWidth' | 'fullHeight' | 'fullHeightFullWidth' | 'dialog' | undefined;
export interface ModalState {
	displayModal: boolean;
	modalProps?: ModalProps;
	previousFocusElement?: string; // Store a unique identifier for the previously focused element
}

interface ModalProps {
	title?: string;
	subtitle?: string;
	content?: string | React.ReactNode;
	fields?: any[]; // or a serializable representation
	actionButtonProps?: {
		title: string;
		type?: ButtonProps['buttonType'];
	};
	className?: string;
	mobileVariation?: MobileVariation;
	isErrorModal?: boolean;
}

const initialState: ModalState = {
	displayModal: false,
	modalProps: undefined,
	previousFocusElement: undefined,
};

export const modalSlice = createSlice({
	name: 'ModalSlice',
	initialState,
	reducers: {
		setModal: (
			state,
			action: PayloadAction<{ displayModal: boolean; modalProps?: ModalProps; previousFocusElement?: string }>
		) => {
			const { displayModal, modalProps, previousFocusElement } = action.payload;

			return {
				displayModal: displayModal,
				modalProps: modalProps,
				previousFocusElement: previousFocusElement ?? state.previousFocusElement,
			};
		},
	},
});

export const { setModal } = modalSlice.actions;
export default modalSlice.reducer;
